<div class="comments" [ngClass]="mode">
  <div class="comments__header">
    <div class="comments__header-counter">
      <ion-label class="color-light">
        {{ commentsCountText() }}
      </ion-label>
    </div>
  </div>

  <div class="comment__input" *ngIf="showTextarea">
    <div class="comment__input-container">
      <div *ngIf="mode === 'comment'" class="avatar">
        <app-avatar [user]="authServ.currentUserValue"> </app-avatar>
      </div>
      <ion-textarea
        rows="1"
        autoGrow="true"
        [(ngModel)]="commentContent"
        placeholder="{{ 'COMMENTS.INPUT_PLACEHOLDER' | translate }}"
        [maxlength]="lengthMax"
      >
        <!-- (ionFocus)="onFocusStateChange(true)"
        (ionBlur)="onFocusStateChange(false)" -->
        <span *ngIf="showCounter || commentContent.length" class="wordCounter"
          >{{ commentContent.length }}/{{ lengthMax }}
        </span>
      </ion-textarea>
      <div class="comment__btn-container">
        <ion-button
          class="comment__button"
          (click)="Save()"
          [disabled]="addingComment"
        >
          <ion-icon name="arrow-redo"></ion-icon>
        </ion-button>
      </div>
    </div>
    <ion-label *ngIf="emptyCommentError" color="danger" class="comment__error font-size__16">
      {{ 'COMMENTS.TRIM_VALIDATION' | translate }}
    </ion-label>
  </div>

  <ion-grid class="comments__comment">
    <ion-row *ngFor="let item of comments; let i = index">
      <ion-col
        *ngIf="i < 3 || showComments"
        [size]="mode === 'comment' ? 12 : 11"
        [offset]="mode === 'comment' ? 0 : 1"
        class="other-message message"
        [ngClass]="
          userPerformedBy !== item.idUserCreated
            ? 'other-message'
            : 'my-message'
        "
        [offset]="
          mode === 'comment' || userPerformedBy !== item.idUserCreated ? 0 : 1
        "
      >
        <div class="comment-box">
          <div class="avatar">
            <app-avatar [user]="item.user"> </app-avatar>
          </div>

          <div class="comment-box__content">
            <div class="comment-box__header">
              <span class="comment-box__author"
                >{{ item.user.firstName }} {{ item.user.lastName }}</span
              >
              <div class="comment-box__time-and-del">
                <span class="comment-box__time">
                  {{ item.createdAt | dateSti }}
                </span>
                <div
                  *ngIf="
                    buttonsList.length > 0 ||
                    canDelete(item.user.id, item.automaticallyGenerated)
                  "
                  (click)="presentPopover($event, item)"
                  class="options-button"
                  [ngClass]="
                    mode !== 'chat'
                      ? 'comment-box__delete'
                      : userPerformedBy !== item.idUserCreated
                      ? 'comment-box__delete'
                      : 'comment-box__delete-my-com'
                  "
                >
                  <ion-icon
                    name="ellipsis-horizontal"
                    slot="icon-only"
                  ></ion-icon>
                </div>
              </div>
            </div>
            <div>
              <div [innerHTML]="item.content"></div>
            </div>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div *ngIf="showSpinnerLoading" class="ion-text-center">
      <app-loading-sti></app-loading-sti>
    </div>

    <ng-container *ngIf="comments">
      <div *ngIf="comments.length > 3 && !showComments">
        <ion-item button (click)="loadComments(true)" lines="none">
          <ion-label class="color-pink ion-text-center">
            {{ 'COMMENTS.SEE_MORE_COMMENTS' | translate }} ({{
              comments.length - 3
            }})
          </ion-label>
        </ion-item>
      </div>
    </ng-container>
  </ion-grid>
</div>
